<template>
  <div id="history">
    <!-- 历史激活记录 -->
    <ul class="list">
      <li v-for="(item, index) in list" :key="index">
        <div class="num">
          <p class="green">{{item.activationContent}}</p>
        </div>
        <div class="info">
          <p>激活时间：{{item.activationTime}}</p>
          <p>激 活 码：{{item.activationCode}}</p>
        </div>
      </li>
    </ul>
    <div class="no-data" v-if="list.length == 0">
      <img src="@/static/images/other/wushuju.png" alt="暂无数据" />
      <p class="green">暂无数据</p>
    </div>
    <div class="btn">
      <mt-button size="large" type="primary" @click="changeRouter('exchange')"
        >去激活</mt-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //激活历史   
    getList() {
      this.post(this.apis.activateTicketHis, {
        memberId: this.userInfo.memberId,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.list = response.data.list;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
};
</script>

<style lang="less" scoped>
#history {
  padding: 0 30px;
  .list {
    margin-bottom: 180px;
    li {
      height: 150px;
      border-bottom: 1px solid #c5c5c5;
      display: flex;
      .num {
        flex: 0 0 230px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .info {
        color: #575757;
        flex: 1;
        padding-top: 26px;
        p {
          line-height: 50px;
        }
      }
    }
  }
  .no-data {
    text-align: center;
    img {
      width: 210px;
      height: 179px;
    }
    p {
      padding-top: 53px;
    }
  }
  .btn {
    width: 690px;
    position: fixed;
    bottom: 0;
    height: 150px;
    background-color: #fff;
  }
}
</style>
